import { useState } from "react";
import { FaCircleInfo } from "react-icons/fa6";

export const InputField: React.FC<{
  id: string;
  name: string;
  label: string;
  type?: string;
  value: string;
  placeholder?: string;
  tooltip?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({
  id,
  name,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  tooltip,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <div className="relative">
      <label
        htmlFor={id}
        className="flex justify-between font-medium text-[var(--uat-gray)] mb-2"
      >
        {label}
        {tooltip && (
          <button
            type="button"
            className="text-gray-500 hover:text-blue-600"
            onClick={() => setShowTooltip(!showTooltip)}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <FaCircleInfo className="w-4 h-4" />
          </button>
        )}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full rounded-lg bg-white/60 border border-gray-200 px-4 py-3 text-sm outline-none focus:border-[var(--uat-blue)]"
      />
      {showTooltip && (
        <div className="absolute top-0 right-0 md:right-[-10rem] w-40 bg-gray-800 text-white text-sm rounded-lg px-3 py-2 shadow-lg z-10">
          {tooltip}
          <div className="absolute top-2 left-[-6px] w-2 h-2 bg-gray-800 rotate-45"></div>
        </div>
      )}
    </div>
  );
};
